import { isNodeProd } from '@zhenguo/jssdk/base/env'
import { autoMV, lxMC } from '@zhenguo/jssdk/lx'

function processBindingValue(props, labToStr = true) {
  let bid
  let lab
  if (typeof props === 'string') {
    bid = props
  } else if (props && props.bid) {
    bid = props.bid
    if (props.lab) {
      lab = labToStr ? JSON.stringify(props.lab) : props.lab
    }
  }
  return {
    bid,
    lab,
  }
}

export default function (app) {
  app.directive('lxmv', {
    bind: function (el, binding) {
      if (!(el instanceof Element)) return
      const { bid, lab } = processBindingValue(binding.value)
      if (!bid || bid === 'undefined') return
      el.dataset.mv = bid
      if (lab) el.dataset.lab = lab
      autoMV.observe(el)
    },
    unbind: function (el) {
      if (!(el instanceof Element)) return
      autoMV.unobserve(el)
    },
    update: function (el, binding) {
      if (!(el instanceof Element)) return
      const { bid, lab } = processBindingValue(binding.value)
      const oldValue = processBindingValue(binding.oldValue)
      if (oldValue.bid && !bid) {
        autoMV.unobserve(el)
        return
      }
      if (oldValue.bid === bid) {
        return
      }
      el.dataset.mv = bid
      if (lab) el.dataset.lab = lab
      if (!isNodeProd()) {
        console.log('ubind', el.dataset.mv)
      }
      autoMV.observe(el)
    },
  })
  app.directive('lxmc', {
    bind: function (el, binding) {
      if (!(el instanceof Element)) return
      const { bid, lab } = processBindingValue(binding.value, false)
      if (!bid || bid === 'undefined') return
      el.addEventListener('click', () => {
        lxMC(bid, lab)
      })
    },
  })
}
